import TableRowSkeleton from '@components/common/Table/TableRowSkeleton'

const AssetAccessLoading: React.FC = () => {
  return <TableRowSkeleton height="26px" rows={2} />
}

export default AssetAccessLoading
